import i18n from "../../i18n";
import { PronunciationPosition } from "../settings/PronunciationPosition";
import {
  getLearningIntervalUnitCountFromLocalStorage,
  getLearningPronunciationPositionFromLocalStroage,
} from "../settings/learningSettings";
import Term from "../term/Term";
import LearningContinue from "./LearningContinue";
import LearningHistoryTermsResult from "./LearningHistoryTerms";
import { LearningMode } from "./LearningMode";
import { LearningHistoryRange } from "./learningHistoryRange";

export const NO_LIMIT = 0;

export function getTermsUsingDefaultTerms(
  defaultTerms: Term[],
  terms: Term[]
): Term[] {
  return terms.filter((term) =>
    defaultTerms.some((defaultTerm) => defaultTerm.id === term.id)
  );
}

export function getLearningRangeText(range: LearningHistoryRange) {
  switch (range) {
    case LearningHistoryRange.day:
      return i18n.t("LearningTodayLearnedText");
    case LearningHistoryRange.week:
      return i18n.t("LearningWeekLearnedText");
    case LearningHistoryRange.month:
      return i18n.t("LearningMonthLearnedText");
  }
}

export function getDailyTargetMessage(
  learningHistoryTerms: LearningHistoryTermsResult | undefined
): string {
  if (learningHistoryTerms == undefined) {
    return "";
  }
  if (learningHistoryTerms.correctTermsCount < learningHistoryTerms.goalCount) {
    return i18n.t("LearningGoalMessageDayInLearning");
  } else {
    return i18n.t("LearningGoalMessageDayComplete");
  }
}

export function getPageSize(
  termsCount: number,
  learningContinue: LearningContinue | null
): number {
  if (learningContinue !== null) {
    return learningContinue.itemSize;
  }

  const intervalUnitCount = getLearningIntervalUnitCountFromLocalStorage();
  if (intervalUnitCount == NO_LIMIT) {
    return termsCount;
  } else {
    return intervalUnitCount;
  }
}

export function isLastCard(
  learnedTermsCount: number,
  totalTermsCount: number
): boolean {
  return learnedTermsCount >= totalTermsCount;
}

export function getCurrentCount(
  learningMode: LearningMode,
  currentPage: number,
  currentIndex: number,
  totalTermsCount: number,
  learningContinue: LearningContinue | null
): number {
  switch (learningMode) {
    case LearningMode.normal:
      return (
        currentPage * getPageSize(totalTermsCount, learningContinue) +
        currentIndex +
        1
      );
    case LearningMode.restartOnlyIncorrectTerms:
      return currentIndex + 1;
    case LearningMode.restartFromLearningHistory:
      return currentIndex + 1;
  }
}

export function getTotalCount(
  learningMode: LearningMode,
  currentPage: number,
  learningTermsCount: number,
  learningContinue: LearningContinue | null
): number {
  if (learningContinue !== null) {
    return currentPage * learningContinue.itemSize + learningTermsCount;
  }

  switch (learningMode) {
    case LearningMode.normal:
      const intervalUnitCount = getLearningIntervalUnitCountFromLocalStorage();
      if (intervalUnitCount == NO_LIMIT) {
        return learningTermsCount;
      } else {
        const totalCount = currentPage * intervalUnitCount + learningTermsCount;
        return totalCount;
      }
    case LearningMode.restartOnlyIncorrectTerms:
      return learningTermsCount;
    case LearningMode.restartFromLearningHistory:
      return learningTermsCount;
  }
}

export function isShowMemo(value: string, front: "front" | "back"): boolean {
  return value.length !== 0 && front !== "front";
}

export function isShowPronunciation(
  value: string,
  front: "front" | "back",
  firstQuestion: "term" | "definition"
): boolean {
  if (value.length === 0) {
    return false;
  }

  switch (firstQuestion) {
    case "term":
      if (
        getLearningPronunciationPositionFromLocalStroage() ===
        PronunciationPosition.onTerm
      ) {
        if (front === "front") {
          return true;
        }
      } else {
        if (front === "back") {
          return true;
        }
      }
      break;
    case "definition":
      if (
        getLearningPronunciationPositionFromLocalStroage() ===
        PronunciationPosition.onTerm
      ) {
        if (front === "back") {
          return true;
        }
      } else {
        if (front === "front") {
          return true;
        }
      }
      break;
  }
  return false;
}
